import SensDataRole from './SensDataRole'

export default SensDataRole



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/dataauth-set/index.jsx